import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import automationBlocks from "../commons/automationBlocks";

export const automationDesignStore = new Vuex.Store({
    state: {
        diagram: null,
        debugPayload: null,
        variables: [
            { name: 'Entry' },
            { name: 'Form' },
        ]
    },
    mutations: {
        setDiagram(state, data) {
            state.diagram = data;
        },
        setDebugPayload(state, data) {
            state.debugPayload = data;
        }
    },
    actions: {
        async loadDiagram({ commit, dispatch }, payload) {
            commit('setDiagram', payload);
            dispatch('updateVariables');
        },
        async debugPayload({ commit, dispatch }, payload) {
            commit('setDebugPayload', payload);
        },
        async updateVariables({ state, commit }, payload) {
            automationBlocks.computeVariables(state.diagram);
            window.eventBus.$emit("refreshAutomationBlocks");
        },
    }
})